import { IPrescription } from 'API';

export const instanceOfIPrescription = (
  object: any
): object is IPrescription => {
  return 'status' in object && 'medications' in object;
};
